module.exports = __webpack_public_path__ + "img/SKMJ_heavy10.53a1fc1e.jpg";